export default __webpack_public_path__ + "static/media/Pistol_1.d7a4b1c7.png";